var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2c1.827 0 3.518.457 5.072 1.37a9.478 9.478 0 0 1 3.558 3.558A9.834 9.834 0 0 1 22 12a9.834 9.834 0 0 1-1.37 5.072 9.478 9.478 0 0 1-3.558 3.558A9.834 9.834 0 0 1 12 22a9.834 9.834 0 0 1-5.072-1.37 9.657 9.657 0 0 1-3.558-3.582A9.791 9.791 0 0 1 2 12a9.79 9.79 0 0 1 1.37-5.048A9.842 9.842 0 0 1 6.952 3.37 9.79 9.79 0 0 1 12 2zm0 18.029a7.814 7.814 0 0 0 4.038-1.106 7.787 7.787 0 0 0 2.885-2.884A7.814 7.814 0 0 0 20.03 12a7.814 7.814 0 0 0-1.106-4.038 7.786 7.786 0 0 0-2.884-2.885A7.814 7.814 0 0 0 12 3.97a7.814 7.814 0 0 0-4.038 1.106 7.785 7.785 0 0 0-2.885 2.885A7.814 7.814 0 0 0 3.97 12c0 1.442.369 2.789 1.106 4.038a7.786 7.786 0 0 0 2.885 2.885A7.814 7.814 0 0 0 12 20.03zm.986-9.015V6.976h-1.972v4.038H6.976v1.972h4.038v4.038h1.972v-4.038h4.038v-1.972h-4.038z",
    fill: "#5f00a0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.a369f820362028c0235da29650eab399.svg";
export { ForwardRef as ReactComponent };